import { ActionType } from '../infrastructure/actionTypes';
import { ISeedCategory } from '../infrastructure/interfaces';

export default (list: ISeedCategory[] = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_SEED_CATEGORIES_DONE:
      const { seedCategories } = action;
      return seedCategories.sort((a: ISeedCategory, b: ISeedCategory) => a.name.localeCompare(b.name));
    case ActionType.GET_SEED_CATEGORY_ATTRIBUTES_DONE:
      const { categoryId, seedAttributes } = action;
      const index = list.findIndex((category: ISeedCategory) => category.id === categoryId);
      if (index > -1) {
        list[index].attributes = seedAttributes;
      }
      return list;
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/seedCategoryList.ts